<template>
  <!-- 店铺信息 -->
  <div class="shopList">
    <div class="shopList__left box-shadow scrollbar flex directionColumn">
      <el-tabs v-model="activeName" class="wHP" style="margin-left: 3%" @tab-click="activeClick">
        <el-tab-pane label="渠道" name="first"></el-tab-pane>
        <el-tab-pane label="区域" name="third"></el-tab-pane>
        <el-tab-pane label="权属" name="fourth"></el-tab-pane>
      </el-tabs>
      <div v-if="activeName === 'third' || activeName === 'fourth'" class="padding10">
        <el-input v-model="filterText" placeholder="分类名称" class="wHP" clearable />
      </div>
      <div>
        <el-tabs v-if="activeName === 'first'" v-model="zType" tab-position="left" @tab-click="handleClick">
          <el-tab-pane label="全部" name="-1"></el-tab-pane>
          <el-tab-pane label="美团闪购" name="1"></el-tab-pane>
          <el-tab-pane label="饿了么零售" name="2"></el-tab-pane>
          <el-tab-pane label="京东到家" name="3"></el-tab-pane>
          <el-tab-pane label="小程序商城" name="4"></el-tab-pane>
        </el-tabs>
        <el-tree v-show="activeName === 'third'" ref="thirdTree" show-checkbox class="filter-tree" :data="data" :default-expand-all="false" :filter-node-method="filterNode" @check-change="handleCheckChange" />
        <el-tree v-show="activeName === 'fourth'" ref="merchantTree" show-checkbox class="filter-tree" :props="merchantProps" :data="merchantList" :default-expand-all="true" :filter-node-method="merchantFilter" @check-change="handleCheckChange" />
      </div>
    </div>

    <div class="shopList__right box-shadow">
      <div class="fs16 fWB borderBottom paddingBottom10">店铺列表</div>
      <dc-search-panel :params="queryPara" @search="doSearch" @reset="resetQueryPara">
        <div style="float: right;">
          <el-select v-model="queryPara.bStatus" placeholder="全部状态">
            <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-model="queryPara.finance" clearable placeholder="输入财务关系" class="marginLeft10 w250 input-with-select" />
          <el-input v-model="queryPara.cName" clearable placeholder="输入店铺名称" class="marginLeft10 w250 input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
          </el-input>
        </div>
        <div style="margin-top: 10px">
          <el-dropdown v-hasPermi="['shop:shopAuthorize:shopSync']" split-button type="primary" :loading="syncLoading" @click="syncShop" @command="syncShop">
            同步绑定店铺
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">拉取美团店铺信息</el-dropdown-item>
              <el-dropdown-item command="2">拉取饿了么店铺信息</el-dropdown-item>
              <el-dropdown-item command="3">拉取京东到家店铺信息</el-dropdown-item>
              <el-dropdown-item command="4">拉取小程序店铺信息</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>&nbsp;
          <el-button slot="append" :disabled="shopIds.length === 0" @click="financeDialogVis = true">设置财务关系</el-button>
        </div>
      </dc-search-panel>
      <dc-datatable ref="list" :url="urlApi" :params="queryPara" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column label="序号" align="center" type="index" width="60" />
        <el-table-column align="center" label="所属渠道" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.ztype === 1" style="color:chocolate;">美团闪购</span>
            <span v-else-if="scope.row.ztype === 2" style="color:dodgerblue;">饿了么零售</span>
            <span v-else-if="scope.row.ztype === 3" style="color:darkgreen;">京东到家</span>
            <span v-if="scope.row.ztype === 4" style="color:chocolate;">小程序商城</span>
          </template>
        </el-table-column>
        <el-table-column prop="rplatShop" align="center" label="平台店铺ID" />
        <el-table-column prop="cname" align="center" label="店铺名称" />
        <el-table-column align="center" label="营业状态" width="70">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.bstatus">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="sfinance" align="center" label="财务关系"/>
        <el-table-column prop="sstore" align="center" label="销售部门"/>
        <el-table-column align="center" label="出货门店">
          <template slot-scope="scope">
            <span v-if="scope.row.bbindType === 1">自动分仓</span>
            <span v-else-if="scope.row.bbindType === 2" style="color:blue;">绑定{{ scope.row.storeIds.length }}家</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-hasPermi="['shop:shopAuthorize:shopEdit']" type="text" size="mini" @click="editRow(scope.row.sid)">编辑</el-button>
            <el-button v-hasPermi="['shop:shopAuthorize:shopDel']" type="text" size="mini" @click="detailRow(scope.row.sid, scope.row.storeIds)">绑定详情</el-button>
          </template>
        </el-table-column>
      </dc-datatable>
    </div>

    <el-dialog :title="title" :visible.sync="financeDialogVis" width="600" append-to-body>
      <el-table row-key="ccode" @row-click="handleFinaceRowClick" max-height="500px" :data="financeList" style="width: 100%" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column align="center" prop="id" key="id" label="编码" />
        <el-table-column align="center" prop="name" key="name" label="业务单元（财务关系）" />
      </el-table>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="open" width="800" append-to-body>
      <el-row>
        <el-col :span="11">
          <el-form ref="form" :model="form" :rules="rules" label-width="110px">
            <el-form-item label="店铺所属渠道">
              <span v-if="form.ztype === 1">美团闪购</span>
              <span v-else-if="form.ztype === 2">饿了么零售</span>
              <span v-else-if="form.ztype === 3">京东到家</span>
              <span v-if="form.ztype === 4">小程序商城</span>
              <span v-if="form.ztype === 6">Tops商城</span>
            </el-form-item>
            <el-form-item>
              <template slot="label">
                  <span style="color: red;">*</span><span>平台店铺ID号</span>
              </template>
              <span>{{ form.rplatShop }}</span>
            </el-form-item>
            <el-form-item label="平台店铺名称">
              <el-input v-model="form.cname" readonly/>
            </el-form-item>
            <el-form-item >
              <template slot="label">
                <span style="color: red;">*</span><span>销售部门ID</span>
              </template>
              <el-select v-model="form.storeId" filterable placeholder="请选择">
                <el-option v-for="item in saleStoreList" :key="item.sid" :label="item.cname" :value="item.ccode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item >
              <template slot="label">
                <span style="color: red;">*</span><span>所在区域</span>
              </template>
              <el-cascader v-model="form.region" :options="options" :props="defaultProps" @change="onChangeRegion" />
            </el-form-item>
            <el-form-item label="所属商户">
              <el-select v-model="form.rmerchant" filterable placeholder="请选择">
                <el-option v-for="item in merchantList" :key="item.sid" :label="item.c_name" :value="item.sid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <template slot="label">
                <span style="color: red;">*</span><span>财务关系</span>
              </template>
              <el-select v-model="form.cfinance" filterable placeholder="请选择">
                <el-option v-for="item in financeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="营业状态" prop="status">
              <el-switch v-model="form.bstatus"></el-switch>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" :offset="1">
          <el-row>
            <el-col :span="8">
              <span>出货门店</span>
            </el-col>
            <el-col :span="16">
              <el-radio-group v-model="bindType">
                <el-radio :label="1">自动分仓</el-radio>
                <el-radio :label="2">指定门店</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <br>
          <el-row v-show="bindType === 1">
            <div>自动分仓无需选择门店</div>
          </el-row>
          <el-row v-show="bindType === 2">
            <el-table ref="storeTable" row-key="ccode" max-height="340px" :data="storeList" @selection-change="handleSelectionChangeStore" style="width: 100%" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column type="selection" align="center" :reserve-selection="true" width="55"></el-table-column>
              <el-table-column prop="ccode" key="ccode" label="门店编码" />
              <el-table-column prop="cname" key="cname" label="门店名称" width="160"/>
              <el-table-column prop="cfinance" key="cfinance" label="业务单元（财务关系）" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ formatFinance(scope.row.cfinance) }}</span>
                </template>
              </el-table-column>
            </el-table>
            <br>
            <el-row>
              <el-switch v-model="showChooseStore"></el-switch>仅显示选中的记录
            </el-row>
          </el-row>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitForm">保存</el-button>
        <el-button size="small" type="danger" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定详情" :visible.sync="bindDetailVis" width="500px" append-to-body>
      <el-row>
        <el-form ref="form" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="店铺所属渠道">
            <span v-if="form.ztype === 1">美团闪购</span>
            <span v-else-if="form.ztype === 2">饿了么零售</span>
            <span v-else-if="form.ztype === 3">京东到家</span>
            <span v-if="form.ztype === 4">小程序商城</span>
            <span v-if="form.ztype === 6">Tops商城</span>
          </el-form-item>
          <el-form-item>
            <template slot="label">
                <span style="color: red;">*</span><span>平台店铺ID号</span>
            </template>
            <span>{{ form.rplatShop }}</span>
          </el-form-item>
          <el-form-item label="平台店铺名称">
            <span>{{ form.cname }}</span>
          </el-form-item>
          <el-form-item >
              <template slot="label">
                <span style="color: red;">*</span><span>销售部门ID</span>
              </template>
              <span>{{ form.rstore }}</span>
            </el-form-item>
          <el-form-item >
            <template slot="label">
              <span style="color: red;">*</span><span>所在区域</span>
            </template>
            <el-cascader disabled v-model="form.region" :options="options" :props="defaultProps" @change="onChangeRegion" />
          </el-form-item>
          <el-form-item label="所属商户">
            <el-select disabled v-model="form.rmerchant" filterable placeholder="请选择">
              <el-option v-for="item in merchantList" :key="item.sid" :label="item.c_name" :value="item.sid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <span style="color: red;">*</span><span>财务关系</span>
            </template>
            <el-select disabled v-model="form.cfinance" filterable placeholder="请选择">
              <el-option v-for="item in financeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-table row-key="ccode" max-height="340px" :data="bindDetailList" style="width: 100%" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column prop="ccode" key="ccode" label="门店编码" />
              <el-table-column prop="cname" key="cname" label="门店名称" width="160"/>
              <el-table-column prop="cfinance" key="cfinance" label="业务单元（财务关系）" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ formatFinance(scope.row.cfinance) }}</span>
                </template>
              </el-table-column>
            </el-table>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="bindDetailVis = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getShopById, queryAreaList, queryMerchantList, updateShopById } from "@/api/shop/shop";
import baseUrls from "../../api/baseUrls";

export default {
  name: "ShopList",
  props: {},
  data() {
    return {
      activeName: "first",
      zType: '-1',
      shopIds: [],
      storeIds: [],
      tableData: [],
      financeList: [],
      saleStoreList: [],
      open: false,
      financeDialogVis: false,
      bindDetailVis: false,
      title: "店铺修改",
      cname: "",
      data: [],
      bindType: 1,
      form: {},
      merchantList: [],
      merchantProps: {
        children: "children",
        label: "c_name",
      },
      storeList: [],
      srcStoreList: [],
      bindDetailList: [],
      rules: {},
      merchantData: [],
      filterText: "",
      showChooseStore: false,
      merchantText: "",
      queryPara: {
        bStatus: null,
        cName: null,
      },
      syncLoading: false,
      options: [],
      defaultProps: {
        children: "children",
        label: "NODE_NAME",
        value: "NODE_CODE",
      },
      stateOptions: [
        { value: null, label: "全部状态" },
        { value: false, label: "未营业" },
        { value: true, label: "营业中" },
      ],
      bStatus: null,
      urlApi: `${this.baseUrls.orderShop}/queryPageList`,
      url: "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
      tabs: "1",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.thirdTree.filter(val);
      this.$refs.merchantTree.filter(val);
    },
    showChooseStore(nval) {
      if (nval) {
        let arr = []
        for (let i = 0; i < this.storeIds.length; i++) {
          for (let j = 0;j < this.storeList.length; j++) {
            if (this.storeList[j].sid === this.storeIds[i]) {
              arr.push(this.storeList[j])
              break
            }
          }
        }
        this.storeList = arr
      } else {
        this.storeList = this.srcStoreList
      }
    }
  },
  created() {
    queryAreaList().then((response) => {
      this.data = response.data;
    });
    queryMerchantList().then((response) => {
      this.merchantData = response.data;
    });
    this.selectMerchant();
    this.selectFinance();
    // this.selectSaleStoreList();
  },
  methods: {
    selectSaleStoreList() {
      let url = `${this.baseUrls.orderStore}/querySaleList`;
      this.topsAjax.get(url).then((response) => {
        this.saleStoreList = response;
      });
    },
    handleFinaceRowClick(row) {
      let ids = ''
      for (let i = 0; i < this.shopIds.length; i++) {
        if (ids.length > 0) {
          ids += ','
        }
        ids += this.shopIds[i]
      }
      this.topsAjax.post(`${this.baseUrls.orderShop}/bind`, { ids: ids, finance: row.id, financeName: row.name }).then((res) => {
        this.doSearch();
        this.financeDialogVis = false;
        this.$refs.list.clearSelection();
      });
    },
    formatFinance(val) {
      for (let i = 0; i < this.financeList.length; i++) {
        if (this.financeList[i].id === val) {
          return this.financeList[i].name
        }
      }
    },
    onChangeRegion(val) {
      this.form.cprovincial = val[0];
      this.form.ccity = val[1];
      //this.form.carea = val[2];
      this.selectStore(val[1])
    },
    /**
     * 获取省市县数据
     */
    queryBaseAreaList() {
      let url = "/api/system/baseArea/queryList";
      this.topsAjax.get(url).then((res) => {
        res.forEach((item) => {
          if (item.children) {
            item.children.forEach((subItem) => {
              if (subItem.children) {
                delete subItem.children;
              }
            });
          }
        });
        this.options = res;
      });
    },
    resetQueryPara() {
      this.bStatus = null;
      this.zType = "-1";
      this.doSearch();
    },
    handleClick(tab, event) {
      this.doSearch();
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = []
          for (let j = 0; j < this.storeList.length; j++) {
            for (let i = 0; i < this.storeIds.length; i++) {
              if (this.storeList[j].sid === this.storeIds[i]) {
                params.push(this.storeList[j])
                break
              }
            }
          }
          for (let i = 0; i < this.financeList.length; i++) {
            if (this.financeList[i].id === this.form.cfinance) {
              this.form.sfinance = this.financeList[i].name
              break
            }
          }
          this.form.bbindType = this.bindType
          this.topsAjax.post(`${this.baseUrls.orderShop}/updateAndBindStore`, { shop: this.form, params: params }).then((res) => {
            this.open = false;
            this.doSearch();
          });
        }
      });
    },
    cancel() {
      this.open = false;
    },
    selectMerchant() {
      let url = `${this.baseUrls.merchant}/selectMerchantTree`;
      this.topsAjax.get(url).then((res) => {
        let arr = [];
        for (let i = 0; i < res.length; i++) {
          for (let j = 0; j < res[i].children.length; j++) {
            arr.push(res[i].children[j]);
          }
        }
        this.merchantList = arr;
      });
    },
    selectFinance() {
      let url = `${this.baseUrls.orderShop}/financial`;
      //let url = `https://wms.julaiang.com/api/repository/store/financial`;
      this.topsAjax.get(url).then((response) => {
        this.financeList = response;
      });
    },
    selectStore(areaIds) {
      let url = `${this.baseUrls.orderStore}/queryList`;
      this.topsAjax.get(url, { bStatus: 2, cRegion: areaIds }).then((response) => {
        this.storeList = response;
        this.saleStoreList = [ ...response ];
        this.saleStoreList.push({ sid: '999', cname: '默认门店', ccode: this.form.cfinance + '3999' });
        this.srcStoreList = this.storeList;
        this.$refs.storeTable.clearSelection();
        for (let j = 0; j < this.storeList.length; j++) {
          for (let i = 0; i < this.form.storeIds.length; i++) {
            if (this.form.storeIds[i] === this.storeList[j].sid) {
              this.$refs.storeTable.toggleRowSelection(this.storeList[j]);
              break;
            }
          }
        }
      });
    },
    activeClick(tab, event) {
      this.queryPara.zType = null;
      this.queryPara.areaIds = null;
      this.queryPara.merchantIds = null;
      this.queryPara.bStatus = this.bStatus;
      this.queryPara.cName = this.cname;
      this.$refs.list.load();
    },
    detailRow(sid, storeIds) {
      this.bindDetailVis = true
      getShopById(sid).then((response) => {
        this.form = response.data;
        let region = [];
        region.push(this.form.cprovincial);
        region.push(this.form.ccity);
        // region.push(this.form.carea);
        this.form.region = region;
        if (this.form.bbindType === 1) {
          let url = `${this.baseUrls.orderStore}/queryList`;
          this.topsAjax.get(url, { bStatus: 2, cRegion: this.form.ccity }).then((response) => {
            this.bindDetailList = response;
          });
        } else {
          let ids = ''
          for (let i = 0; i < storeIds.length; i++) {
            if (ids.length > 0) {
              ids += ','
            }
            ids += storeIds[i]
          }
          let url = `${this.baseUrls.orderStore}/queryByIds`;
          this.topsAjax.post(url, { ids: ids }).then((response) => {
            this.bindDetailList = response;
          });
        }
      });
      this.queryBaseAreaList();
    },
    editRow(sid) {
      this.open = true;
      getShopById(sid).then((response) => {
        this.form = response.data;
        this.bindType = this.form.bbindType;
        let region = [];
        region.push(this.form.cprovincial);
        region.push(this.form.ccity);
        //region.push(this.form.carea);
        this.form.region = region;
        this.selectStore(this.form.ccity);
      });
      this.queryBaseAreaList();
    },
    handleCheckChange(data, checked) {
      if (checked) {
        let ids;
        if (data.children) {
          ids = data.children.map((node) => node.sid);
        } else {
          ids = data.sid;
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    merchantFilter(value, data) {
      if (!value) return true;
      return data.c_name.indexOf(value) !== -1;
    },
    syncShop(command) {
      this.syncLoading = true;
      let url = `${this.baseUrls.shop}/syncShops/` + command;
      this.topsAjax.get(url).then((res) => {
        this.syncLoading = false;
        if (res === "success") {
          this.$message.success("同步完成");
        } else {
          this.$message.error("同步失败");
        }
        this.doSearch();
      });
    },
    doSearch() {
      if (this.activeName === "third") {
        const checkedNodes = this.$refs.thirdTree.getCheckedNodes();
        this.queryPara.areaIds = checkedNodes.map((node) => node.id) + "";
        this.queryPara.zType = null;
        this.queryPara.merchantIds = null;
      } else if (this.activeName === "first") {
        this.queryPara.zType = this.zType;
        this.queryPara.areaIds = null;
        this.queryPara.merchantIds = null;
      } else if (this.activeName === "fourth") {
        this.queryPara.zType = null;
        this.queryPara.areaIds = null;
        const checkedNodes = this.$refs.merchantTree.getCheckedNodes();
        this.queryPara.merchantIds = checkedNodes.map((node) => node.sid) + "";
      } else {
        this.queryPara.bStatus = this.bStatus;
        this.queryPara.cName = this.cname;
      }
      this.$refs.list.load();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.shopIds = selection.map((item) => item.sid);
    },
    handleSelectionChangeStore(selection) {
      this.storeIds = selection.map((item) => item.sid);
    },
    handleHeaderRowStyle() {
      return "background: '#f5f7fa'; color: '#606266'"
    }
  },
};
</script>

<style lang="scss" scoped>
.shopList {
  display: flex;
  flex-direction: row;
  height: 100%;
  flex: 1;
  overflow: hidden;

  &__left {
    width: 15%;
    background-color: white;
    margin: 3px;
    margin-right: 15px;
  }

  &__right {
    padding: 10px;
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 3px;
    background-color: white;
  }
}
</style>

<style lang="scss">
.el-tabs--left .el-tabs__item.is-left {
  text-align: left;
}

.el-tabs--left .el-tabs__header.is-left {
  width: 100%;
}

.father1 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
</style>
